export default {"src":"/_next/static/media/copy-icon-02.303a80cf.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};